import { safeDefine } from "../../registration/safe-define.js";
import { ScaffoldLiveAudioSkinElement } from "../../presets/live-audio/scaffold-skin.js";
import "../../internal/skins/scaffold-live-audio/register.js";
//#region src/define/live-audio/scaffold-skin.ts
safeDefine(ScaffoldLiveAudioSkinElement);
//#endregion

//# sourceMappingURL=scaffold-skin.js.map